import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=6ecccf60"
import script from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=6ecccf60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports